import { ContentStack, Margins, TDocumentDefinitions } from "pdfmake/interfaces";
import { getCompanyFont } from "../../common/CompanyLogoForm";
import { HeaderCheckupReport, HeaderCheckupReportProps } from "../../common/HeaderPdfFormTemplate";
import { Cover, FooterCheckupReportProps } from "./CheckupReportType";
import { formatISOtoBEDateTime } from "react-lib/utils/dateUtils";
import CONFIG from "config/config";

/*================================ PROPS ==============================*/

interface ContentStackWithId extends Omit<ContentStack, "stack"> {
  id?: string;
  stack: ContentStack["stack"];
}

export interface ITDocumentDefinitions extends TDocumentDefinitions {
  content: (ContentStackWithId | TDocumentDefinitions["content"])[];
}

export const FORM_NAME: string = "FormCheckupReport";
export const DEFAULT_FONT_SIZES: number = 14;
export const DEFAULT_LOGO_HEIGHT: number = 40;
export const DEFAULT_HEADER_MARGINS: Margins = [40, 10, 40, 20];
export const DEFAULT_PAGE_MARGINS: Margins = [40, 140, 40, 80];
export const DEFAULT_LANGUAGE: "th" | "en" = "th";

/*================================ HEADER FORM ==============================*/

export const getCheckupReportHeader = async (props: Partial<HeaderCheckupReportProps>) => {
  const defaultProps: HeaderCheckupReportProps = {
    detail: {} as Cover,
    language: DEFAULT_LANGUAGE,
    font: getCompanyFont(),
    form: FORM_NAME,
    headerMargins: DEFAULT_HEADER_MARGINS,
    logoHeight: DEFAULT_LOGO_HEIGHT,
    pageMargins: DEFAULT_PAGE_MARGINS,
    isMainReport: true,
  };

  return await HeaderCheckupReport({ ...defaultProps, ...props });
};

/*================================ FOOTER FORM ==============================*/

export const getCheckupReportFooter = (
  props: Partial<FooterCheckupReportProps>
): ContentStack | null => {
  const { currentPage, countPage, footerData, language, isMainReport = true } = props;

  if (isMainReport && currentPage === 1) return null;

  const isEng = language === "en";

  // RAMASRI
  let hospitalDetail = [
    "ศูนย์การแพทย์รามาธิบดีศรีอยุธยา Ramathibodi Sri Ayutthaya Medical Center",
    "404 ถ.ศรีอยุธยา แขวงถนนพญาไท เขตราชเทวี กรุงเทพมหานคร 10400",
    "404 Thanon Si Ayutthaya, Khwaeng Thanon Phaya Thai, Khet Ratchathewi, Bangkok 10400",
  ];

  if (CONFIG.COMPANY === "SAPIENS") {
    hospitalDetail = [
      "โรงพยาบาล เซเปี้ยนซ์ Sapiens Pain Hospital",
      "498/7 ซอยรามคำแหง 39 (เทพลีลา 1) แขวงวังทองหลาง เขตวังทองหลาง กรุงเทพฯ 10310",
      "498/7 Soi Ramkhamhaeng (Thepleela 1) Wang Thonglang, Wang Thonglang Bangkok 10310",
    ];
  }

  return {
    stack: [
      {
        text: hospitalDetail[0],
        style: "footer_title",
        bold: true,
        alignment: "center",
      },
      {
        text: hospitalDetail[1],
        style: "footer_title",
        alignment: "center",
      },
      {
        text: hospitalDetail[2],
        style: "footer_title",
        alignment: "center",
        marginBottom: 10,
      },
      {
        columns: [
          {
            text: [
              { text: isEng ? "Printed date " : "วันเวลาที่พิมพ์เอกสาร " },
              { text: formatISOtoBEDateTime(footerData?.currentDate).dateTimeShort || "" },
            ],
            style: "footer_info",
            width: "auto",
          },
          {
            text: [{ text: isEng ? "by " : "โดย " }, { text: footerData?.printer || "" }],
            style: "footer_info",
            width: "auto",
          },
        ],
        columnGap: 10,
      },
    ],
    margin: [40, 0, 40, 0],
  };
};
